import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IFlashLocationProfile, IFlashPool } from 'src/app/shared/code/interfaces/parcs-interfaces';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';

export interface IFlashAddNewAccountRequest {
  profileId: string;
  // Flash resolves the profile by NAME; the uniqueID is only what the dropdown is keyed on.
  profileName: string;
  poolName: string;
}

@Component({
  selector: 'app-dialog-flash-add-new-account',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
  ],
  templateUrl: './dialog-flash-add-new-account.component.html',
  styleUrl: './dialog-flash-add-new-account.component.scss',
})
export class DialogFlashAddNewAccountComponent implements OnInit {
  profileList: IFlashLocationProfile[] = [];
  selectedProfileId: string = '';
  selectedPoolName: string = '';
  // Flash has no "list pools" endpoint, so the names come from the lot's spACE-AR pool admin list.
  poolList: IFlashPool[] = [];
  submitButtonDisabled: boolean = true;
  newFlashAddNewAccountRequest: IFlashAddNewAccountRequest = {} as IFlashAddNewAccountRequest;

  //Services
  #_parcsDataService = inject(ParcsDataService);

  constructor(
    public _dialogRef: MatDialogRef<DialogFlashAddNewAccountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.getProfileList();
    this.getPoolList();
  }

  // Returns HTTP 200 even on a Flash-side failure, so isSuccess decides, not the status code.
  getProfileList(): void {
    this.#_parcsDataService.flash_GetProfilesByLotNumber(this.data.lotNumber).subscribe({
      next: (response) => {
        this.profileList = response.isSuccess ? response.locationProfiles : [];
      },
      error: (error) => {
        this.profileList = [];
      },
    });
  }

  getPoolList(): void {
    this.#_parcsDataService.flash_GetPoolsByLotNumber(this.data.lotNumber).subscribe({
      next: (response) => {
        this.poolList = response;
      },
      error: (error) => {
        this.poolList = [];
      },
    });
  }

  onProfileSelectionChange(profileId: string): void {
    this.selectedProfileId = profileId;
    this.buildRequest();
  }

  onPoolSelectionChange(poolName: string): void {
    this.selectedPoolName = poolName;
    this.buildRequest();
  }

  private buildRequest(): void {
    this.submitButtonDisabled = this.selectedProfileId === '' || this.selectedPoolName === '';

    this.newFlashAddNewAccountRequest = {
      profileId: this.selectedProfileId,
      profileName: this.profileList.find((profile) => profile.uniqueID === this.selectedProfileId)?.name ?? '',
      poolName: this.selectedPoolName,
    };
  }
}
